'use client';
import React, { useContext, PropsWithChildren, useState } from 'react';
import { CustomSnackbarProps } from '../Snackbar/Snackbar';
import { Snackbar } from '../Snackbar';

export type SnackbarContextProps = {
  onAddSnackBar: (args: CustomSnackbarProps) => void;
  snackBar: CustomSnackbarProps | null;
};

const SnackbarContext = React.createContext<SnackbarContextProps>({
  onAddSnackBar: (args) => {
    /** */
  },
  snackBar: {},
} as SnackbarContextProps);

type Props = {
  /** Live-region role forwarded to the rendered Snackbar. */
  role?: React.AriaRole;
};

/**
 * SnackbarProvider.
 */
export const SnackbarProvider = (props: PropsWithChildren<Props>) => {
  const { children, role } = props;

  const [snackBar, setSnackBar] = useState<CustomSnackbarProps | null>(null);

  const onClose = () => {
    setSnackBar(null);
  };
  const onAddSnackBar = (data: CustomSnackbarProps) => setSnackBar(data);

  return (
    <SnackbarContext.Provider
      value={{
        onAddSnackBar,
        snackBar,
      }}
    >
      {children}
      <Snackbar
        isVisible={!!snackBar}
        hide={onClose}
        role={role}
        {...snackBar}
      />
    </SnackbarContext.Provider>
  );
};

/**
 * Snackbar context.
 */
export const useSnackbarContext = () => useContext(SnackbarContext);
